export default defineNuxtPlugin(() => {
  !(function (t, e, n, s, a, c, i, o, p) {
    ((t.AppsFlyerSdkObject = a),
      (t.AF =
        t.AF ||
        function () {
          (t.AF.q = t.AF.q || []).push([Date.now()].concat(Array.prototype.slice.call(arguments)));
        }),
      (t.AF.id = t.AF.id || i),
      (t.AF.plugins = {}),
      (o = e.createElement(n)),
      (p = e.getElementsByTagName(n)[0]),
      (o.async = 1),
      (o.src =
        'https://websdk.appsflyer.com?' +
        (c.length > 0 ? 'st=' + c.split(',').sort().join(',') + '&' : '') +
        (i.length > 0 ? 'af_id=' + i : '')),
      p.parentNode.insertBefore(o, p));
  })(window, document, 'script', 0, 'AF', 'banners', {
    banners: { key: '91768c14-a4d4-4455-8418-0877467f1304' },
  });
  AF('banners', 'showBanner');
});
